export default () => ({
    activeItem: '',
    collapsable: true,

    async init() {
        this.activeItem = '1';
    },

    trigger: {
        ['@click']() {
            let collapsable = this.$el.parentNode.classList.contains('collapsable')
            if (collapsable && this.activeItem == this.$el.dataset.item) {
                this.activeItem = '';
                return;
            }
            this.activeItem = this.$el.dataset.item
        },
        [':class']: 'activeItem === $el.dataset.item ? "--is-active" : ""',
        [':aria-expanded']: 'activeItem === $el.dataset.item',
        [':aria-label']: '"toggle element"'
    },

    content: {
        ['x-show']: 'activeItem === $el.dataset.item',
    },

    toggle() {
        this.activeItem = this.$el.dataset.item
    },
})
